import * as s from './ModalContext.module.scss'

export const getModalContainer = () => document.querySelector(`.${s.portalContainer}`)
export const EXIT_ANIMATION_DURATION = 0.2
export const OPEN_ANIMATION_DURATION = 0.2
